export const DOCUMENT_TYPES = [
  'Scheduling Packet',
  'H&P',
  'Imaging',
  'PT Notes',
  'Operative Report',
  'Discharge Summary',
  'Lab Results',
  'Consultation Notes',
  'Therapy Notes',
  'Other',
] as const;

export type DocumentTypeName = (typeof DOCUMENT_TYPES)[number];

export const TYPE_COLORS: Record<string, string> = {
  'Scheduling Packet': '#f97316',
  'H&P': '#3b82f6',
  'Imaging': '#8b5cf6',
  'PT Notes': '#06b6d4',
  'Operative Report': '#ec4899',
  'Discharge Summary': '#f59e0b',
  'Lab Results': '#10b981',
  'Consultation Notes': '#6366f1',
  'Therapy Notes': '#14b8a6',
  'Other': '#64748b',
};
